import React, { useState } from "react";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import { useSelector } from "react-redux";
import axios from "axios";
import Config from "../../Config";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import InitiateTenantEvictionStepOne from "./InitiateTenantEvictionStepOne";
import tw from "tailwind-styled-components";
import InitiateTenantEvictionStepTwo from "./InitiateTenanteEvictionStepTwo";
import { UserImage, ProfileSection, UserInfo, Underline } from "../Styles/PageStyles";
import Images from "../../Images";
import { FaCheck } from "react-icons/fa6";
import AddDuesModal from "./AddDuesModal";
import SideModal from "../SideModal";
import { capitalizeFirstLetter } from "../../helpers";

const InitiateTenantEviction = ({ setInitiateEviction, apiData, selfi, tenantId, data, rentStartDate }) => {
    const navigate = useNavigate();
    const user = useSelector((state) => state.UserReducer.user);
    const [step, setStep] = useState(1);
    const [stepOneData, setStepOneData] = useState(null);
    const [isAddDuesModal, setIsAddDuesModal] = useState(false);
    //------- Tenant Due List -------
    const tenantDueListFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/due/tenant/list/new`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const tenantDueListSuccess = (data, variables) => {
        setStep(2)
        setStepOneData(variables);
        // toast.success(data?.data?.msg || "Success");
    };

    const tenantDueListError = (data) => {

        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoadding: tenantDueListLoading, mutate: tenantDuelistMutate, data: dueData } =
        useMutation(tenantDueListFunction, {
            onSuccess: tenantDueListSuccess,
            onError: tenantDueListError,
        });

    //------- Edit Due Tenant -------
    const editDueFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/due/edit/new`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };
    const onEditDueSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            // toast.success(data?.data?.msg || "Success");
            tenantDuelistMutate({
                tenantId: stepOneData.tenantId,
                date: stepOneData.date,
                moveOutReason: stepOneData?.moveOutReason,
                calculateDues: 0,
            });
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onEditDueError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: editDueLoading, mutate: editDueMutate } =
        useMutation(editDueFunction, {
            onSuccess: onEditDueSuccess,
            onError: onEditDueError,
        });

    //------- Initiate Eviction Tenant -------
    const initiateEvictionFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/user/tenant/remove`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };
    const onInitiateEvictionSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            navigate("/inventory/operational")
            setInitiateEviction(false)
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onInitiateEvictionError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: initiateEvictionLoading, mutate: initiateEvictionMutate } =
        useMutation(initiateEvictionFunction, {
            onSuccess: onInitiateEvictionSuccess,
            onError: onInitiateEvictionError,
        });

    const handleClose = () => {
        setStep(1);
        setInitiateEviction(false);
    };

    const handlePrevStep = () => {
        setStep(1);
    };
    const [step1Values, setStep1Values] = useState({
        moveOutDate: "",
        otherDate: "",
        calculationType: "",
        agreementDate: "",
        moveOutReason: "",
    });
    //------- Add Due Model -------
    const AddDueFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/due/add/new`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const addDueSuccess = (data) => {
        setIsAddDuesModal(false);
        tenantDuelistMutate({
            tenantId: stepOneData.tenantId,
            date: stepOneData.date,
            moveOutReason: stepOneData?.moveOutReason,
            calculateDues: 0,
        });
        // if (!initiateEviction) {
        //   getListMutate();
        // }
        toast.success(data?.data?.msg || "Success");
    };

    const addDueError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addDuesLoading, mutate: addDuesMutate } = useMutation(
        AddDueFunction,
        {
            onSuccess: addDueSuccess,
            onError: addDueError,
        }
    );
    return (
        <Container>
            <Header>
                <h1 className="text-white text-lg font-medium">Move Out</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <ProfileSection>
                <div className="flex-row flex">
                    <UserImage className='w-11 h-11' src={selfi ? selfi : Images.Avatar} alt={`Avatar for ${apiData?.name}`} />
                    {(apiData?.kycStatus === 5 || apiData?.kycStatus === 4) &&
                        <div className="mt-auto rounded-full bg-green-500 h-4 w-4 flex items-center justify-center -ml-2.5">
                            <FaCheck className="text-white" size={10} />
                        </div>
                    }
                </div>
                <UserInfo>
                    <span className="font-medium">{apiData?.name}</span>
                    <span className="text-sm text-gray-600">
                    {capitalizeFirstLetter(
                        [
                        apiData?.occupancy?.flatNo && `#${apiData.occupancy.flatNo},`,
                        apiData?.occupancy?.inventoryName
                        ]
                        .filter(Boolean)
                        .join(" ")
                    )}
                    </span>                </UserInfo>
            </ProfileSection>
            <div className="px-0 h-full flex flex-col justify-between">
                {step === 1 && (
                    <InitiateTenantEvictionStepOne
                        setInitiateEviction={setInitiateEviction}
                        //data={apiData?.occupancy || selectedData}
                        data={apiData?.occupancy}
                        tenantDueListLoading={tenantDueListLoading}
                        tenantDuelistMutate={tenantDuelistMutate}
                        initialFormValues={step1Values}
                        setStep1Values={setStep1Values}
                    />
                )}
                {step === 2 && (
                    <InitiateTenantEvictionStepTwo
                        data={dueData}
                        //routeData={apiData?.occupancy || selectedData}
                        routeData={apiData?.occupancy}
                        setInitiateEviction={setInitiateEviction}
                        editDueMutate={editDueMutate}
                        editDueLoading={editDueLoading}
                        setStep={setStep}
                        initiateEvictionLoading={initiateEvictionLoading}
                        initiateEvictionMutate={initiateEvictionMutate}
                        stepOneData={stepOneData}
                        handlePrevStep={handlePrevStep}
                        step1Values={step1Values}
                        setIsAddDuesModal={setIsAddDuesModal}
                    />
                )}
                <SideModal
                    isOpen={isAddDuesModal}
                    onClose={() => setIsAddDuesModal(false)}
                    level="high"
                    width="11/12"
                >
                    <AddDuesModal
                        setIsAddDuesModal={setIsAddDuesModal}
                        addDuesMutate={addDuesMutate}
                        addDuesLoading={addDuesLoading}
                        isAddDuesModal={isAddDuesModal}
                        tenantId={tenantId}
                        data={data}
                        rentStartDate={rentStartDate}
                        initiateEvictionFlow="true"
                    />
                </SideModal>

            </div>
        </Container>
    );
};
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
export default InitiateTenantEviction;
